import React from 'react';
import { cn } from '../../../lib/utils';

/**
 * DailyDashboardShell — 3-column dashboard scaffold (PRD §8.6).
 *
 * Left (≈1.15fr): Now + Unplanned panes (stacked)
 * Middle (≈1.7fr): Day Timeline pane
 * Right (≈1.15fr): Scheduled / Backlog / Recovery / Assistant panes (stacked)
 *
 * Mobile collapses to a single column via `MobileDailyDashboardTabs`.
 */
export function DailyDashboardShell({
  commandBand,
  left,
  center,
  right,
  floatingSaveBar,
  className,
  ...rest
}) {
  return (
    <div
      className={cn('flex flex-col gap-4 min-h-0', className)}
      data-testid="daily-dashboard-shell"
      {...rest}
    >
      {commandBand}
      <div
        className="flex-1 min-h-0 grid gap-4 grid-cols-1 lg:grid-cols-12 auto-rows-min"
        data-testid="daily-dashboard-grid"
      >
        <div className="lg:col-span-3 flex flex-col gap-4 min-h-0" data-testid="daily-dashboard-left">
          {left}
        </div>
        <div className="lg:col-span-6 min-h-0" data-testid="daily-dashboard-center">
          {center}
        </div>
        <div className="lg:col-span-3 flex flex-col gap-4 min-h-0" data-testid="daily-dashboard-right">
          {right}
        </div>
      </div>
      {floatingSaveBar}
    </div>
  );
}

export default DailyDashboardShell;
